module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('section')
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-15a20f70"}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/views/member-center/right/deposite.vue
// module id = 1536
// module chunks = 1